export const VEHICLE_STORAGE_KEY = 'active-vehicle';

// ROUTES
export const LOGIN_PATH = 'inloggen';
export const LOGIN_ROUTE = `/${LOGIN_PATH}`;
export const DISTANCE_PATH = 'ritten';
export const DISTANCE_ROUTE = `/${DISTANCE_PATH}`;
export const VEHICLES_PATH = 'voertuigen';
export const VEHICLES_ROUTE = `/${VEHICLES_PATH}`;
export const AUTHENTICATED_URL = DISTANCE_ROUTE;